<template>
    <div id="seccion-principal-PA" >
        <div v-show="!programaciones.ALTA.mostrarSeccionFormulario" id="seccion-monitoreo.PA">
            <div id="encabezados-tp">
                <h1>Control de audiencias</h1>
                <h3>Realiza las modificaciones para el control audiencias</h3>
                <!-- <div class="hr-titulo"></div> -->
            </div>
            <div class="d-flex justify-content-center">
                <div id="alert-cambios-guardados" style="margin-top: -2em;" class="alert alert-success d-none col-3" role="alert">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <i style="font-size: 2em;" class="fas fa-check-circle"></i>
                        </div>
                        <div>
                            Los cambios de guardaron de manera correcta
                        </div>
                    </div>
                </div>
            </div>
            <div class="margen-main-GT">
                <div class="filtros-busqueda">
                     <h6>
                    <!-- <i @click="programaciones.FILTROS_BUSQUEDA.fechaAudiencia.activo = !programaciones.FILTROS_BUSQUEDA.fechaAudiencia.activo" 
                                :class="(!programaciones.FILTROS_BUSQUEDA.fechaAudiencia.activo) ? 'far fa-square' : 'fas fa-check-square'"
                                style="cursor: pointer;"></i>&nbsp;&nbsp; -->Fecha de audiencia:
                    </h6>
                    <input class="form-control col-2" @change="getAudienciasEvtFecha" v-model="programaciones.FILTROS_BUSQUEDA.fechaAudiencia.valor" type="date">
                    <button v-tooltip:right="'Actualizar tabla desde base de datos'" @click="ejecutarProcesoGetAudiencias({ conLoading: true, limpiarListaEdicion: true })" type="button" class="btn btn-sm btn-dark"><i class="fas fa-sync"></i></button>
                </div>
            </div>
            <!-- SECCION PRINCIPAL DE PROGRAMACION -->
            <div class="tabla-audiencias-VPA margen-main-GT">
                <div id="toolbar-tabla-progrmacion-PA">
                    <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                        <!-- <button v-tooltip:left="'Actualizar tabla desde base de datos'" @click="ejecutarProcesoGetAudiencias({ conLoading: true, limpiarListaEdicion: true })" type="button" class="btn btn-sm btn-dark"><i class="fas fa-sync"></i></button> -->
                        <!-- <button type="button" @click="programaciones.ALTA.mostrarSeccionFormulario = true" class="btn btn-sm btn-info"><i class="fas fa-plus"></i>&nbsp;&nbsp;Programar audiencia</button> -->
                        <div class="form-inline flex-wrap" style="gap: 2em !important;">
                            <!-- <button v-if="programacionesAEditar > 0" @click="ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: true, esEdicion: true })" type="button" class="btn btn-sm btn-info"><i class="fas fa-edit"></i>&nbsp;&nbsp;Guardar cambios</button> -->
                            <button v-if="programacionesAEliminar > 0" @click="accionModal({ idReferenciaModal: 'modal-confirmacion-eliminar-VPA', mostrar: true })" type="button" class="btn btn-danger"><i class="fas fa-trash"></i>&nbsp;&nbsp;Eliminar</button>
                            <div class="form-inline flex-wrap newSectionFilters" style="gap: 0.5em !important;">
                            <!-- <CCatalogoGenerico class="p-0 m-0 filtro-partido-VPDAUD" 
                                    v-on:valorParaElPadre="evtCambioTipoPartido" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.ID" 
                                    :valorDefinido="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido"
                                    :textoOpcionesSingular="''"
                                    :textoOpcionesPlural="''"
                                    :elementosCatalogo="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opciones"
                                    :conOpcionDeinstrucciones="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.mostrarSoloOpcionesValidas"
                                    :key="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.KEY + programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.contRender"></CCatalogoGenerico> -->
                                    <multiselect
                                        style="width: 420px !important;"
                                        v-model="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas" 
                                        tag-placeholder="Agregar como nuevo partido" 
                                        placeholder="Buscar partido" 
                                        label="valor" 
                                        track-by="llave" 
                                        :options="programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opciones" 
                                        :multiple="true" 
                                        :taggable="true" 
                                        @select="evtAgregarPartidoFiltros"
                                        @remove="evtRemoverPartidoFiltros"></multiselect> 
                                    <button type="button" class="btn btn-light" 
                                        @click="evtMostrarTodosLosPartidos" 
                                        v-tooltip:right="'Mostrar por todos los partidos'"><i class="fas fa-trash"></i>
                                    </button>   
                            </div>
                        </div>
                    </div>
                </div>
                <table
                    class="table table-striped table-light table-hover"
                    :id="programaciones.TABLA.ID"              
                    data-toggle="table"
                    data-pagination="true"
                    data-toolbar="#toolbar-tabla-progrmacion-PA"
                    data-undefined-text="-" 
                    data-maintain-meta-data="true"
                    data-click-to-select="false"
                    data-page-size = "1000"
                    data-page-list="[5,10,20,30,40, 50, 60, 70, 80, 90, 100, 200, 300, 1000]"
                    data-show-toggle="true"
                    data-show-pagination-switch="true"
                    data-detail-view="true"
                    data-search="true"
                    data-custom-search="customSearch"
                    data-trim-on-search="false"
                     data-detail-formatter="detailFilter"
                    data-show-columns="true"
                    data-show-fullscreen="true"
                    data-show-columns-toggle-all="true"
                    >
                    <thead class="thead-dark">
                        <tr>
                            <th data-halign="center" data-width="6" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="partidoJudicial" data-sortable="true">
                                PARTIDO
                            </th>
                            <th data-halign="center" data-width="38" data-align="center" data-events="operateEvents" data-field="carpetaEditable" data-sortable="true">
                                CARPETA
                            </th>
                            <th data-halign="center" data-width="15" data-align="center" data-events="operateEvents" data-field="horaEditable" data-sortable="true">
                                HORA
                            </th>
                            <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="salaEditable" data-sortable="true">
                                SALA
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="modoEditable" data-sortable="true">
                                MODO
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="zoomEditable" data-sortable="true">
                                ZOOM
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="audienciaSTR" data-sortable="true">
                                AUDIENCIA
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="detenidoEditable" data-sortable="true">
                                DETENIDO
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="auxiliarEditable" data-sortable="true">
                                AUXILIAR
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="juezEditable" data-sortable="true">
                                JUEZ
                            </th>
                            <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="pantallaEditable" data-sortable="true">
                                PANTALLA
                            </th>
                            <th data-halign="center" data-width="15" data-align="center" data-events="operateEvents" data-field="estadoEditable" data-sortable="true">
                                ESTADO
                            </th>
                            <th data-halign="center" data-width="38" data-align="center" data-field="fechaAudienciaSTR" data-sortable="true">
                                FECHA
                            </th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="id" data-sortable="true">
                                ID
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <div v-show="programaciones.ALTA.mostrarSeccionFormulario" id="seccion-formulario-creacion-VPDA" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2">
                <div id="encabezados-tp">
                    <h1>Registro de audiencia</h1>
                    <h3>crea la programación de la audiencia</h3>
                    <button type="button" @click="programaciones.ALTA.mostrarSeccionFormulario = false" class="btn btn-sm btn-dark"><i class="fas fa-chevron-circle-left"></i>&nbsp;&nbsp;Regresar a tabla de control</button>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2" id="contendor-formulario">
                <div class="card">
                    <div class="card-header">
                        <div class="form-inline justify-content-between flex-wrap">
                            <h5 class="form-inline">
                                <strong>FORMULARIO DE REGISTRO</strong>&nbsp;&nbsp;
                            </h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <CFormularioProgramacionAudiencia
                            :idElemento="programaciones.ALTA.ID_ELEMENTO"
                            :esParaEdicion="programaciones.ALTA.esParaEdicion"
                            :jueces="CATALOGOS.tiposJuez"
                            :zoom="CATALOGOS.tiposZoom"
                            :tiposAudiencia="CATALOGOS.tiposAudiencias"
                            :detenidos="CATALOGOS.tiposDetenido"
                            :partidosJudiciales="CATALOGOS.partidoJudicial"
                            :audiencias="CATALOGOS.audiencias"
                            v-on:GetDatosFormulario="getDatosFormularioAlta"
                            v-on:actualizarAgenda="evtActaulizarTablaDeAgendaFormulario"
                            :key="programaciones.ALTA.KEY + programaciones.ALTA.contRender"
                            :ref="programaciones.ALTA.REF"
                        ></CFormularioProgramacionAudiencia>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2">
                <div class="tabla-audiencias-VPA">
                    <div id="toolbar-tabla-agenda-formVPDA">
                        <h4>Agenda</h4>
                    </div>
                    <table
                        class="table table-light table-hover"
                        :id="programaciones.ALTA.TABLA.ID"              
                        data-toggle="table"
                        data-pagination="true"
                        data-toolbar="#toolbar-tabla-agenda-formVPDA"
                        data-undefined-text="Sin información" 
                        data-maintain-meta-data="true"
                        data-click-to-select="false"
                        data-page-size = "30"
                        data-page-list="[10,20,30, 40, 50, 60, 70, 80, 90, 100]"
                        data-show-toggle="false"
                        data-show-pagination-switch="true"
                        data-row-style="aplicarEstilosPorPartidoJudicial"
                        data-search="true">
                        <thead class="thead-dark">
                            <tr>
                                <th data-halign="center" data-width="10" data-align="center" data-field="partido" data-sortable="true">
                                    PARTIDO
                                </th>
                                <th data-halign="center" data-width="38" data-align="center" data-field="carpeta" data-sortable="true">
                                    CARPETA
                                </th>
                                <th data-halign="center" data-width="15" data-align="center" data-field="hora" data-sortable="true">
                                    HORA
                                </th>
                                <th data-halign="center" data-width="10" data-align="center" data-field="audiencia" data-sortable="true">
                                    AUDIENCIA
                                </th>
                                <th data-halign="center" data-width="6" data-align="center" data-field="juez" data-sortable="true">
                                    JUEZ
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
        <!-- MODAL FORMULARIO ALTA -->
       <!--  <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-mostrar-seccion-formulario-VPA">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento de solicitud</h5>
                        <button  id="modal-mostrar-seccion-formulario-VPA" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 1em 2em 1em 2em !important;">
                        <CFormularioProgramacionAudiencia
                            :idElemento="programaciones.ALTA.ID_ELEMENTO"
                            :esParaEdicion="programaciones.ALTA.esParaEdicion"
                            :jueces="programaciones.CATALOGOS.tiposJuez"
                            :zoom="programaciones.CATALOGOS.tiposZoom"
                            :tiposAudiencia="programaciones.CATALOGOS.tiposAudiencias"
                            :detenidos="programaciones.CATALOGOS.tiposDetenido"
                            :partidosJudiciales="programaciones.CATALOGOS.partidoJudicial"
                            v-on:GetDatosFormulario="getDatosFormularioAlta"
                            :key="programaciones.ALTA.KEY + programaciones.ALTA.contRender"
                        ></CFormularioProgramacionAudiencia>
                    </div>           
                </div>
            </div>
        </div> -->
        <!-- MODAL CONFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmacion-eliminar-VPA">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>
                                Se eliminarán las programaciones de audiencias seleccionadas,<br>
                                ¿Deseas continuar?
                            </h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="ejecutarProcesoEliminarProgramaciones({ conLoading: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="accionModal({ idReferenciaModal: 'modal-confirmacion-eliminar-VPA', mostrar: false })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { campoEsValido } from "../../SINOJ/Comun/Funciones/validaciones.js"
import { inicializarTabla, actualizarFilas, insertarFilas, eliminarFilas } from "../Programacion/Funciones/Tablas.js"
import CFormularioProgramacionAudiencia from "../Programacion/Comun/CFormularioProgramacionAudiencia.vue"
import { servicioRestPost } from './servicios/ServiciosHttp.js'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api';
import moment from 'moment'
import sistemas from '@/../static/js/sistemas'
import {CATALOGOS} from '../Catalogos/CatalogosBD.js'
import enumeraciones from '@/../static/js/enumeraciones'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        CFormularioProgramacionAudiencia: CFormularioProgramacionAudiencia,
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        Multiselect 
    },
    data() {
        return {
            CATALOGOS,
            campoEsValido,
            inicializarTabla,
            actualizarFilas,
            insertarFilas,
            eliminarFilas,
            servicioRestPost,
            moment,
            enumeraciones,
            programaciones: {
                TABLA: {
                    ID: 'Id-tablaProgramacionAudiencias-PA',
                    lista: [
                        { id: 1,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '655 358 1024',audiencia: 'prueba',detenido: 'sin',auxiliar: 'Daniel',juez: 'Aristoteles',pantalla: 'Visible',estado: 'Pasar a sala'},
                        { id: 2,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Video',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Juan',juez: 'Aristoteles',pantalla: 'Visible',estado: 'Pasar a sala'},
                        { id: 3,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Daniel',juez: 'Otro',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 4,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Video',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'sin',auxiliar: 'Juan',juez: 'Otro',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 5,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Video',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'sin',auxiliar: 'Juan',juez: 'Aristoteles',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 6,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Daniel',juez: 'Aristoteles',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 7,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Daniel',juez: 'Aristoteles',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 8,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Daniel',juez: 'Aristoteles',pantalla: 'Oculta',estado: 'Iniciada'},
                        { id: 9,carpeta: '0001/2020',hora: '12:00',sala: 5,modo: 'Presencial',zoom: '292 168 3662',audiencia: 'prueba',detenido: 'con',auxiliar: 'Daniel',juez: 'Aristoteles',pantalla: 'Oculta',estado: 'Iniciada'},
                    ],
                    listaParaEdicion: []
                },
                ALTA: {
                    ID_ELEMENTO: 'ID_FORMULARIO_ALTA_PA',
                    esParaEdicion: false,
                    datosFormulario: null,
                    KEY: 'K_FORMULARIO_ALTA_PA',
                    REF: 'R_FORMULARIO_ALTA_PA',
                    contRender: 0,
                    mostrarSeccionFormulario: false,
                    TABLA: {
                        ID: 'Id-tablaAgendaJuez-PA',
                        lista: [],
                    },
                },
                FILTROS_BUSQUEDA: {
                    fechaAudiencia: {
                        valor: moment().format('YYYY-MM-DD'),
                        activo: true
                    },
                    CPartidoJudicial: {
                        ID: 'CTipoPartidoJudicial_VGPAUD',
                        KEY: 'KEY_CTipoPartidoJudicial_VGPAUD',
                        valorDefinido: -1,
                        opciones: [
                           /*  { llave: "-1", valor: "Mostrar por todos los partidos" }, */
                            { llave: "1", valor: "1 - Aguascalientes" },
                            { llave: "2", valor: "2 - Calvillo" },
                            { llave: "3", valor: "3 - Pabellón" },
                            { llave: "4", valor: "4 - Rincón de Romos" },
                            { llave: "5", valor: "5 - Jesús María" },
                            { llave: "6", valor: "6 - Adolescentes" },
                        ],
                        mostrarSoloOpcionesValidas: false,
                        contRender: 0,
                        opcionesSeleccionadas: [],
                        mostrarTodosLosPartidos: true
                    },
                },
            }
        }
    },
    watch: {
        'programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas': async function() {
            await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        }
    },
    methods: {
        evtMostrarTodosLosPartidos: async function() {
            this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas = [];
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        evtRemoverPartidoFiltros: async function(partidoObj) {
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        evtAgregarPartidoFiltros: async function(partidoObj) {
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        filtradoMultiplePartidosJudiciales: async function() { debugger
            let mostrarPorTodos = this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas.length < 1;
            if(mostrarPorTodos) {
                await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.TABLA.ID, elementos: this.programaciones.TABLA.lista, callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
            }
            else {
                //console.log('this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas::',this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas);
                await Promise.resolve(inicializarTabla(
                    { idReferencia: this.programaciones.TABLA.ID, 
                        elementos: this.programaciones.TABLA.lista.filter(p => this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas.some(opSel => opSel.llave == p.partidoJudicial)), 
                        callbackCheck: () => {}, 
                        callbackPaginacion: this.desplegarQuienRegistra 
                    }));
            }
            this.desplegarQuienRegistra();
        },
        evtCambioTipoPartido: async function(evento) { debugger
            this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido = parseInt(evento.target.value);
            if(this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido < 1) {
                await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.TABLA.ID, elementos: this.programaciones.TABLA.lista, callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
            }
            else {
                await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.TABLA.ID, elementos: this.programaciones.TABLA.lista.filter(p => p.partidoJudicial == this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido), callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
            }
            this.desplegarQuienRegistra();
        },
        evtActaulizarTablaDeAgendaFormulario: async function(filtros) {
            this.ejecutarProcesoGetAudienciasPorJuez({ conLoading: true, filtrosPeticion: filtros });
        },
        ejecutarProcesoGetAudienciasPorJuez: async function({ conLoading, filtrosPeticion }) {
        //    console.log('ejecutarProcesoGetAudienciasPorJuez::filtros::',filtrosPeticion);
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GET_AUDIENCIAS = { 
                    EsPrueba: false, 
                    FechaDeAudiencia: campoEsValido({ campoAValidar: filtrosPeticion.fecha }) ? filtrosPeticion.fecha : null,
                    Juez: campoEsValido({ campoAValidar: filtrosPeticion.juez }) ? filtrosPeticion.juez : null
                }
                const { CON_ERROR, RESPUESTA: { Audiencias } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.ObtenerAudienciasDeJuez,
                    peticionServicio: PETICION_GET_AUDIENCIAS,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                //    console.log('Audiencias juez::', Audiencias);
                    this.programaciones.ALTA.TABLA.lista = campoEsValido({ campoAValidar: Audiencias })
                        ? Audiencias.map(aDB => {
                            let audienciaObj = { ...aDB };
                            let nombreAudiencia = CATALOGOS.tiposAudiencias.find(ta => ta.llave == audienciaObj.audiencia);
                            audienciaObj.audiencia = campoEsValido({ campoAValidar: nombreAudiencia }) ? nombreAudiencia.valor : "-";
                            audienciaObj.hora = moment(audienciaObj.fecha).format('hh:mm A');
                            return audienciaObj;
                        })
                        : [];
                    await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.ALTA.TABLA.ID, elementos: this.programaciones.ALTA.TABLA.lista, callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
                    // SE inicializa el valor del filtrado de partifdo
                    /* if(campoEsValido({ campoAValidar: Audiencias })) {
                        await Promise.resolve(this.evtCambioTipoPartido({ target: { value: this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido } }))
                    } */
                    //this.desplegarQuienRegistra();
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getAudienciasEvtFecha: async function(evento) {
            if(evento.target.value != null && evento.target.value != undefined) {
                await Promise.resolve(this.ejecutarProcesoGetAudiencias({ conLoading: true, limpiarListaEdicion: true }));
            }
        },
        ejecutarProcesoEliminarProgramaciones: async function({ conLoading }) {
            this.accionModal({ idReferenciaModal: 'modal-confirmacion-eliminar-VPA', mostrar: false })
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const programacionesAEliminnar = this.programaciones.TABLA.lista
                    .filter(p => p.seleccionado)
                    .map(p => {
                        let programacionObj = { ...p };
                        delete programacionObj['carpetaEditable'];
                        delete programacionObj['fechaAudienciaSTR'];
                        delete programacionObj['horaEditable'];
                        delete programacionObj['modoEditable'];
                        delete programacionObj['zoomEditable'];
                        delete programacionObj['detenidoEditable'];
                        delete programacionObj['auxiliarEditable'];
                        delete programacionObj['juezEditable'];
                        delete programacionObj['pantallaEditable'];
                        delete programacionObj['estadoEditable'];
                        delete programacionObj['seleccionado'];
                        delete programacionObj['salaEditable'];
                        delete programacionObj['audienciaSTR'];
                        return programacionObj;
                    });
                const PETICION_ELIMINAR_PROGRAMACIONES = { EsPrueba: false, Programaciones: programacionesAEliminnar };
                const { CON_ERROR, RESPUESTA: { AudienciasProgramadas } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.EliminarProgramacionDeAudiencias,
                    peticionServicio: PETICION_ELIMINAR_PROGRAMACIONES,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    if(AudienciasProgramadas.length > 0) {
                        let filasEliminar = AudienciasProgramadas.map(a => a.id);
                        eliminarFilas({ 
                            idReferenciaTabla: this.programaciones.TABLA.ID, 
                            filas: filasEliminar, 
                            llaveElemento: 'id'
                        });
                        this.programaciones.TABLA.listaParaEdicion = this.programaciones.TABLA.listaParaEdicion.filter(pE => !AudienciasProgramadas.some(p => p.id == pE.id));
                        this.desplegarQuienRegistra();
                    }
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getDatosFormularioAlta: function(datos) {
            this.programaciones.ALTA.datosFormulario = datos;
            //this.accionModal({ idReferenciaModal: 'modal-mostrar-seccion-formulario-VPA', mostrar: false });
            this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: true });
            /* console.log('datosFormulario::', this.programaciones.ALTA.datosFormulario); */
        },
        ejecutarProcesoGuardarProgramacionesAudiencias: async function({ conLoading, esEdicion = false }) {
            
            try {
                const PETICION_GUARDAR_PROGRAMACIONES = await Promise.resolve(this.getPeticionGuardarProgramacion({ esEdicion: esEdicion }));
                const { CON_ERROR, RESPUESTA: { AudienciasProgramadas } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.GuardarProgramacionDeAudiencias,
                    peticionServicio: PETICION_GUARDAR_PROGRAMACIONES,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    if(AudienciasProgramadas.length > 0) {
                        if(esEdicion) {
                            let progamacionesActualizadas = AudienciasProgramadas.map(ap => {
                                return this.getProgramcionEditableObj({ p: ap});
                            });
                            
                            actualizarFilas({ 
                                idReferenciaTabla: this.programaciones.TABLA.ID, 
                                filas: progamacionesActualizadas.filter(p => p.estado != 'Concluida'), 
                                llaveElemento: 'id'
                            });
                            if(campoEsValido({ campoAValidar: progamacionesActualizadas.filter(p => p.estado == 'Concluida') })) {
                                eliminarFilas({ 
                                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                                    filas: progamacionesActualizadas.filter(p => p.estado == 'Concluida').map(a => a.id), 
                                    llaveElemento: 'id'
                                });
                            }
                            this.programaciones.TABLA.listaParaEdicion = [];
                            this.desplegarQuienRegistra();
                            //comun.mensajeDeAlerta('Los cambios se guardaron de manera correcta')
                            // SE ACTUALIZA LA TABLA DE AGENDA 
                            this.$nextTick(async () => { 
                                /* let filtrosObj = {
                                    fecha: campoEsValido({ campoAValidar: this.$refs[this.programaciones.ALTA.REF].formulario.fechaAudiencia }) ? this.$refs[this.programaciones.ALTA.REF].formulario.fechaAudiencia : null,
                                    juez: campoEsValido({ campoAValidar: this.$refs[this.programaciones.ALTA.REF].formulario.juez }) && this.$refs[this.programaciones.ALTA.REF].formulario.juez != -1 ? this.$refs[this.programaciones.ALTA.REF].formulario.juez : null
                                };
                                if(campoEsValido({ campoAValidar: filtrosObj.fecha })) {
                                    await Promise.resolve(this.evtActaulizarTablaDeAgendaFormulario(filtrosObj));
                                } */
                                /* $('#alert-cambios-guardados').removeClass('d-none');
  
                                setTimeout(() => {
                                    $('#alert-cambios-guardados').addClass('d-none');
                                }, 500); */
                            });
                        }
                        else {
                            let nuevaProgramacion = this.getProgramcionEditableObj({ p: AudienciasProgramadas[0]});
                            insertarFilas({ 
                                idReferenciaTabla: this.programaciones.TABLA.ID, 
                                filas: [nuevaProgramacion], 
                                index: (this.programaciones.TABLA.lista.length + 1)
                            })
                            this.programaciones.ALTA.contRender ++;
                            this.programaciones.ALTA.datosFormulario;
                            this.programaciones.ALTA.mostrarSeccionFormulario = false;
                            comun.mensajeDeAlerta('La programación de la audiencia se guardó de manera correcta')
                            this.programaciones.ALTA.TABLA.lista = [];
                            await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.ALTA.TABLA.ID, elementos: this.programaciones.ALTA.TABLA.lista, callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
                            this.desplegarQuienRegistra();
                            /* this.$nextTick(() => {
                                $('#alert-cambios-guardados').removeClass('d-none');
  
                                setTimeout(() => {
                                    $('#alert-cambios-guardados').addClass('d-none');
                                }, 500);
                            }); */
                        }
                    }
                    /* this.programaciones.ALTA.contRender ++;
                    this.programaciones.ALTA.datosFormulario;
                    this.programaciones.ALTA.mostrarSeccionFormulario = false;
                    comun.mensajeDeAlerta('La programación de la audiencia se guardó de manera correcta')
                    this.programaciones.ALTA.TABLA.lista = [];
                    await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.ALTA.TABLA.ID, elementos: this.programaciones.ALTA.TABLA.lista }));
                    this.programaciones.TABLA.listaParaEdicion = []; */
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getPeticionGuardarProgramacion: async function({ esEdicion }) { debugger
            let peticionAPI = { EsPrueba: false, Programaciones: [] };
            if(!esEdicion) {
                const { fechaAudiencia, juez, zoomId, partidoJudicial, 
                    horaAudiencia, tipoDeCarpeta, carpeta, carpetaA, 
                    tipoAudienciaId, detenidoId, fechaAudienciaConHora, 
                    juezDos, juezTres, audiencia, nombreEvento, fechaTerminoEvento } = this.programaciones.ALTA.datosFormulario;
                peticionAPI.Programaciones.push({
                    id: -1,
                    fechaAudiencia: fechaAudienciaConHora,
                    partidoJudicial: partidoJudicial,
                    carpeta: `${ carpeta }/${ carpetaA }`,
                    tipoCarpeta: tipoDeCarpeta,
                    hora: null,
                    sala: null,
                    modo: null,
                    zoom: zoomId,
                    audiencia: tipoAudienciaId,
                    detenido: detenidoId,
                    auxiliar: null,
                    juez: juez,
                    pantalla: (campoEsValido({ campoAValidar: tipoAudienciaId }) && tipoAudienciaId.trim() == 'Audiencia Vía Telefónica') ? 0 : 1,
                    estado: null,
                    audienciaEliminada: 0,
                    juezDos: juezDos,
                    juezTres: juezTres,
                    esAudiencia: audiencia,
                    nombreEvento: nombreEvento,
                    fechaTerminoEvento: fechaTerminoEvento
                });
            }
            else {
                peticionAPI.Programaciones = this.programaciones.TABLA.listaParaEdicion;
            }
           // console.log('peticionAPI.Programaciones::',peticionAPI.Programaciones);
            return peticionAPI;
        },
        accionModal: function({ idReferenciaModal, mostrar }) {
            let accionSTR = (mostrar) ? 'show' : 'hide';
            $("#" + idReferenciaModal).modal(accionSTR);
        },
        getHTMLcatalogoConSeleccion: function({ opcionesDelFormulario, valorSeleccionado, cssInput }) { 
            let opcionesHTML = opcionesDelFormulario.map(opcion => {
                let opcionSTR = (opcion.llave == valorSeleccionado) 
                    ? `<option value="${ opcion.llave }" selected>${ opcion.valor }</option>`
                    : `<option value="${ opcion.llave }">${ opcion.valor }</option>`;
                return opcionSTR;
            });
            if(valorSeleccionado == null || valorSeleccionado == undefined) {
                opcionesHTML = `<option value="-1" selected></option>${ opcionesHTML }`
            }
            else {
                opcionesHTML = `<option value="-1"></option>${ opcionesHTML }`
            }
            let htmlConSeleccion = `<select class="form-control ${ cssInput }">
                                        ${ opcionesHTML }
                                     </select>`;
            return htmlConSeleccion;
        },
        ejecutarProcesoGetAudiencias: async function({ conLoading, limpiarListaEdicion = false }) {
            if(limpiarListaEdicion)
                this.programaciones.TABLA.listaParaEdicion = [];

            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const { fechaAudiencia } = this.programaciones.FILTROS_BUSQUEDA;
                const PETICION_GET_AUDIENCIAS = { EsPrueba: false, FechaAudiencia: (fechaAudiencia.activo) ? fechaAudiencia.valor : null, conCocluidas: false }
                const { CON_ERROR, RESPUESTA: { AudienciasProgramadas } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.ObtenerAudienciasProgramadas,
                    peticionServicio: PETICION_GET_AUDIENCIAS,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                   // console.log(AudienciasProgramadas);
                    await Promise.resolve(this.getListaProgramicionesConEditables({ elementos: AudienciasProgramadas }));
                    await Promise.resolve(inicializarTabla({ idReferencia: this.programaciones.TABLA.ID, elementos: this.programaciones.TABLA.lista, callbackCheck: () => {}, callbackPaginacion: this.desplegarQuienRegistra }));
                    this.desplegarQuienRegistra();

                    /* this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido = -1;
                    this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.contRender ++; */

                    /* Proceso de filtrdo individual de partiod 
                    if(campoEsValido({ campoAValidar: AudienciasProgramadas })) {
                        await Promise.resolve(this.evtCambioTipoPartido({ target: { value: this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido } }))
                    } */

                    if(campoEsValido({ campoAValidar: AudienciasProgramadas })) {
                        await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
                    }
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getListaProgramicionesConEditables: async function({ elementos }) {
            this.programaciones.TABLA.lista = elementos.map(programacion => {
                return this.getProgramcionEditableObj({ p: programacion});
            });
        },
        getProgramcionEditableObj: function({ p }) {
            moment.locale('es');
            const { tiposModo, tiposZoom, tiposDetenido, tiposAxiliar, tiposJuez, tiposPantalla, tiposEstado, tiposSalas } = CATALOGOS;
            let pObj = { ...p };
            pObj.audienciaSTR = p.audiencia;
            pObj.seleccionado = false;
            pObj.fechaAudienciaSTR =  (pObj.fechaAudiencia != null) ? `${ moment(pObj.fechaAudiencia).format("DD/MM/YYYY") }` : '-';
            pObj.carpetaEditable  = `<input class="form-control inputs-sm-edicion-VPA carpeta-edicion-VPA" value="${ p.carpeta }" type="text">`;
            /* pObj.salaEditable     = `<input class="form-control inputs-xs-edicion-VPA sala-edicion-VPA" value="${ (p.sala != null) ? p.sala : '' }" type="text">`; */
            pObj.salaEditable     = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposSalas, valorSeleccionado: p.sala, cssInput: 'inputs-xs-edicion-VPA sala-edicion-VPA' });
            pObj.horaEditable     = `<input class="form-control inputs-md-edicion-VPA hora-edicion-VPA" value="${ p.hora }" type="time">`;
            pObj.modoEditable     = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposModo, valorSeleccionado: p.modo, cssInput: 'inputs-xs-edicion-VPA modo-edicion-VPA' });
            pObj.zoomEditable     = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposZoom, valorSeleccionado: p.zoom, cssInput: 'inputs-lg-edicion-VPA zoom-edicion-VPA' });
            pObj.detenidoEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposDetenido, valorSeleccionado: p.detenido, cssInput: 'inputs-xs-edicion-VPA detenido-edicion-VPA' });;
            pObj.auxiliarEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposAxiliar, valorSeleccionado: p.auxiliar, cssInput: 'inputs-md-edicion-VPA auxiliar-edicion-VPA' });;
            pObj.juezEditable     = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposJuez, valorSeleccionado: p.juez, cssInput: 'inputs-lg-edicion-VPA juez-edicion-VPA' });;
            pObj.pantallaEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposPantalla, valorSeleccionado: p.pantalla, cssInput: 'inputs-md-edicion-VPA pantalla-edicion-VPA'});;
            pObj.estadoEditable   = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: tiposEstado, valorSeleccionado: p.estado, cssInput: 'inputs-md-edicion-VPA estado-edicion-VPA' });;
            return pObj;
        },
        agregarProgramacionEnlistaParaEdicion: function({ programacion }) {
            let programacionModificada = this.programaciones.TABLA.listaParaEdicion.find(pEd => pEd.id == programacion.pEd);
            if(programacionModificada != null && programacionModificada != undefined) {
                let programacionActualizada = { ...programacion };
                delete programacionActualizada['carpetaEditable'];
                delete programacionActualizada['fechaAudienciaSTR'];
                delete programacionActualizada['horaEditable'];
                delete programacionActualizada['modoEditable'];
                delete programacionActualizada['zoomEditable'];
                delete programacionActualizada['detenidoEditable'];
                delete programacionActualizada['auxiliarEditable'];
                delete programacionActualizada['juezEditable'];
                delete programacionActualizada['pantallaEditable'];
                delete programacionActualizada['estadoEditable'];
                delete programacionActualizada['seleccionado'];
                delete programacionActualizada['salaEditable'];
                delete programacionActualizada['audienciaSTR'];
                programacionModificada = programacionActualizada;
            }
            else {
                let programacionActualizada = { ...programacion };
                delete programacionActualizada['carpetaEditable'];
                delete programacionActualizada['fechaAudienciaSTR'];
                delete programacionActualizada['horaEditable'];
                delete programacionActualizada['modoEditable'];
                delete programacionActualizada['zoomEditable'];
                delete programacionActualizada['detenidoEditable'];
                delete programacionActualizada['auxiliarEditable'];
                delete programacionActualizada['juezEditable'];
                delete programacionActualizada['pantallaEditable'];
                delete programacionActualizada['estadoEditable'];
                delete programacionActualizada['seleccionado'];
                delete programacionActualizada['salaEditable'];
                delete programacionActualizada['audienciaSTR'];
                this.programaciones.TABLA.listaParaEdicion.push(programacionActualizada);
            }
        },
        desplegarQuienRegistra: function() {
            /* this.$nextTick(() => {
                $(".detail-icon").trigger("click");
            }); */
        }
    },
    computed: {
        programacionesAEliminar() {
            return this.programaciones.TABLA.lista.filter(p => p.seleccionado).length;
        },
        programacionesAEditar() {
            return this.programaciones.TABLA.listaParaEdicion.length;
        },
    },
    async mounted() {
        window.operateEvents = {
            'change .carpeta-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.carpeta = e.target.value;
                filaActualizada.carpetaEditable = `<input class="form-control inputs-sm-edicion-VPA carpeta-edicion-VPA" value="${ e.target.value }" type="text">`;
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .sala-edicion-VPA': (e, value, row, index) => { 
                /* let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.sala = e.target.value;
                filaActualizada.salaEditable = `<input class="form-control inputs-xs-edicion-VPA sala-edicion-VPA" value="${ e.target.value }" type="text">`;
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                }); */

                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.sala = e.target.value != '-1' ? e.target.value : null;;
                filaActualizada.salaEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposSalas, valorSeleccionado: filaActualizada.sala, cssInput: 'inputs-xs-edicion-VPA sala-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .hora-edicion-VPA': (e, value, row, index) => { debugger
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.hora = e.target.value;
                filaActualizada.horaEditable = `<input class="form-control inputs-md-edicion-VPA hora-edicion-VPA" value="${ filaActualizada.hora }" type="time">`;

                let fecha = (filaActualizada.fechaAudiencia != null) ? moment(filaActualizada.fechaAudiencia).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                let dateTime = `${fecha} ${filaActualizada.hora}`;
                filaActualizada.fechaAudiencia = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .modo-edicion-VPA': (e, value, row, index) => { debugger
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.modo = e.target.value != '-1' ? e.target.value : null;;
                filaActualizada.modoEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposModo, valorSeleccionado: filaActualizada.modo, cssInput: 'inputs-xs-edicion-VPA modo-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });

                filaActualizada.pantalla = (filaActualizada.modo == 'Tel.') ? 0 : 1;
                filaActualizada.pantallaEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposPantalla, valorSeleccionado: filaActualizada.pantalla, cssInput: 'inputs-md-edicion-VPA pantalla-edicion-VPA'});
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .zoom-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.zoom = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.zoomEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposZoom, valorSeleccionado: filaActualizada.zoom, cssInput: 'inputs-lg-edicion-VPA zoom-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .detenido-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.detenido = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.detenidoEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario:CATALOGOS.tiposDetenido, valorSeleccionado: filaActualizada.detenido, cssInput: 'inputs-xs-edicion-VPA detenido-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .auxiliar-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.auxiliar = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.auxiliarEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposAxiliar, valorSeleccionado: filaActualizada.auxiliar, cssInput: 'inputs-md-edicion-VPA auxiliar-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .juez-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.juez = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.juezEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposJuez, valorSeleccionado: filaActualizada.juez, cssInput: 'inputs-lg-edicion-VPA juez-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .pantalla-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.pantalla = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.pantallaEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposPantalla, valorSeleccionado: filaActualizada.pantalla, cssInput: 'inputs-md-edicion-VPA pantalla-edicion-VPA'});
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            },
            'change .estado-edicion-VPA': (e, value, row, index) => { 
                let filaActualizada = this.programaciones.TABLA.lista.find(p => p.id == row.id);
                filaActualizada.estado = e.target.value != '-1' ? e.target.value : null;
                filaActualizada.estadoEditable = this.getHTMLcatalogoConSeleccion({ opcionesDelFormulario: CATALOGOS.tiposEstado, valorSeleccionado: filaActualizada.estado, cssInput: 'inputs-md-edicion-VPA estado-edicion-VPA' });
                this.agregarProgramacionEnlistaParaEdicion({ programacion: filaActualizada });
                actualizarFilas({ 
                    idReferenciaTabla: this.programaciones.TABLA.ID, 
                    filas: [filaActualizada], 
                    llaveElemento: 'id'
                });
                this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: false, esEdicion: true });
                this.desplegarQuienRegistra();
            }
        };
        await Promise.resolve(this.ejecutarProcesoGetAudiencias({ conLoading: true }));
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.margen-main-GT {
    padding: 0 3em 0 2em;
}
.mostrar {
    visibility: visible;
    display: block;
}

.ocultar {
    visibility: hidden;
    display: none;
}
/* ========== TITULOS ============== */
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
    background-color: rgb(20, 20, 20);
    padding: 1em 0 0.5em 0;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

/* ========== SECCIONES ============== */
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
    margin-bottom: 2em;
}

#contendor-formulario .card-body {
    background-color: #323335;
}

#contendor-formulario .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contendor-formulario .card-header {
    background-color: rgb(80, 80, 80);
}

#modal-mostrar-seccion-formulario-VPA .modal-lg {
    max-width: 45% !important;
}

#modal-mostrar-seccion-formulario-VPA .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmacion-eliminar-VPA .modal-lg {
    max-width: 30% !important;
}

#modal-confirmacion-eliminar-VPA .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmacion-eliminar-VPA .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

</style>
<style>
/* .multiselect__placeholder {
  display: inline-block !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}


.multiselect.invalid .multiselect__tags {
  border: 1px solid #ff1e1e !important;
}


.multiselect__option--highlight {
  background: #42505c !important;
}

.multiselect__option--highlight:after {
  background: #42505c !important;
}

.multiselect__tags {
  padding: 5px !important;
  min-height: 10px;
}

.multiselect__placeholder{
  margin-left: 10px;
  margin-top: 2px;
}

.multiselect__tag {
  background: #f0f0f0 !important;
  border: 1px solid rgba(60, 60, 60, 0.26) !important;
  color: black !important;
  margin-bottom: 0px !important;
  margin-right: 5px !important;
}

.multiselect__tag-icon:after {
  color: rgba(60, 60, 60, 0.5) !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #f0f0f0 !important;
}

.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: red !important;
}
 */
.contenedor-quienAgenda-audiencia-gestionTmp {
    /* background-color: #6d6d6d; */
    border-radius: 6px;
    padding: 0.5em 1em 0.5em 1em;
    font-size: 1em;
    color: black !important;
    display: inline-flex;
}

.filtro-partido-VPDAUD .form-control {
    background-color: #504f54 !important;
    color: #FFF !important;
}

@media (max-width: 1240px) {
    .tabla-audiencias-VPA td, .tabla-audiencias-VPA th {
        font-size: 0.77em !important;
    }

    .tabla-audiencias-VPA .form-control {
        width: 10em !important;
    }
}

/* .btn-firmantes-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
} */
.tabla-audiencias-VPA {
    padding-bottom: 2em;
    padding-right: 1em;
}

.tabla-audiencias-VPA .btn-sm {
    font-size: .9em !important;
}

.tabla-audiencias-VPA .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-audiencias-VPA .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-audiencias-VPA .inputs-sm-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 6em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-xss-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 4em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-xs-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 5em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-md-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 8em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-lg-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 14em;
    font-size: 1em;
}

/* .tabla-audiencias-VPA td {
    background-color: rgb(223, 223, 223);
    vertical-align: middle;
    font-weight: bold;
} */

.tabla-audiencias-VPA .borderless td, .tabla-audiencias-VPA .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-audiencias-VPA td {
    border: none !important;
    font-size: 1.3em !important;
}

.tabla-audiencias-VPA th {
    font-size: 1.2em !important;
}

.tabla-audiencias-VPA .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}

.tabla-audiencias-VPA .newSectionFilters .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #42505c;
    font-size: 1em;
}


.tabla-audiencias-VPA .btn-edt-cont-intr:hover, .tabla-audiencias-VPA .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.tabla-audiencias-VPA .btn-rmv-cont-intr:hover, .tabla-audiencias-VPA .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.tabla-audiencias-VPA table {
    /* table-layout: fixed;
    width: 100%;
    word-wrap:break-word;  */
}

.tabla-audiencias-VPA .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-audiencias-VPA .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-audiencias-VPA .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-audiencias-VPA > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

</style>


// WEBPACK FOOTER //
// src/components/Audiencias/Programacion/CProgramacion.vue